export const isDevEnv = (tier) => {
  return ['develop', 'redseries', 'greenapple'].includes(tier);
};
